import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Stats() {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-210" data-mp="2wwozfwlobbvf">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-211" data-mp="2iy7eu7r2efhq">
        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center" data-id="element-212" data-mp="296b3huzywsvk">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-213" data-mp="2e0p6ojkvg4as">
            +500
          </div>
          <div className="text-sm text-gray-400 font-medium" data-id="element-214" data-mp="256as6j860xsq">
            personas ya lo usan
          </div>
        </div>

        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center" data-id="element-215" data-mp="1q9084lhgijle">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-216" data-mp="1v8mlqw1761uq">
            6
          </div>
          <div className="text-sm text-gray-400 font-medium" data-id="element-217" data-mp="54os41jm5y6i">Tomos listos</div>
        </div>

        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center" data-id="element-218" data-mp="5ljy88c7bub">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-219" data-mp="e5eiuqu0oydd">
            6
          </div>
          <div className="text-sm text-gray-400 font-medium" data-id="element-220" data-mp="a65q9papr6je">
            Bonos incluidos
          </div>
        </div>

        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center flex flex-col items-center justify-center" data-id="element-221" data-mp="3ikw30vmmil34">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-222" data-mp="3rcpql20kkw27">
            4.9/5
          </div>
          <div className="flex text-brand-gold" data-id="element-223" data-mp="3mlzj9j8l2j4v">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-224" data-mp="2yw5bhg34fkrh" data-mpi={i} />)}
          </div>
        </div>
      </motion.div>
    </section>;
}